import {useCallback, useRef} from 'react'
import {calculateCouponsAmountForItem} from '../../../../utils/coupon-helpers'
import {isFirstCycleFreeRampPlan} from '../../../../features/CatalogGrid/utils/rampPricing'

// Due-today pricing for a 1:Many link. There is no customer account yet, so
// the backend preview (cc/order/preview-payment, which needs an existing
// thryvId) cannot run — this is the same client-side branch the 1:1 Purchase
// Link falls back to for accounts without billing info
// (usePurchaseLinkPaymentPreview): dueTodayAmount = price − coupon discount.
export function useManyLinkPaymentPreview({items, coupons, setItems}) {
  const sequenceRef = useRef(0)

  const refreshPaymentPreview = useCallback(async () => {
    const mySequence = ++sequenceRef.current
    const validCoupons = (coupons ?? []).filter(c => c.isValid)

    const updatedItems = items.map(item => {
      if (item.alreadyIncluded) return {...item, dueTodayAmount: 0}
      const prodType =
        item.productType === 'ONE_TIME_FEE'
          ? 'oneTimeFee'
          : item.productType === 'APP'
          ? 'itemBasedAddon'
          : 'plan'
      const {discountAmount} = calculateCouponsAmountForItem(
        {
          code: item.productCode,
          prodType,
          currency: {unitAmount: item.unitPrice ?? 0},
          // unitPrice is already the line total (unit × quantity); the helper
          // multiplies by quantity itself, so pass 1 to avoid counting it twice.
          quantity: 1,
        },
        validCoupons,
      )
      const upfrontPrice = isFirstCycleFreeRampPlan(item.productCode)
        ? 0
        : item.unitPrice ?? 0
      return {
        ...item,
        dueTodayAmount: Math.max(upfrontPrice - discountAmount, 0),
      }
    })
    if (mySequence !== sequenceRef.current) return null
    setItems(updatedItems)
    return null
  }, [items, coupons, setItems])

  return {refreshPaymentPreview}
}
